<script setup>
import { computed } from 'vue';
import { useMenuInfoStore } from "../stores/menu-info";
const menuInfoStore = useMenuInfoStore();

const props = defineProps({
    text: { type: String },
    value: { type: Number, default() { return 0 } },
    color: { type: String }
})

const percentage = computed({
    get() {
        // this.menuInfoStore.dishes is the total amount of dishes stored in the DB
        let percent = parseFloat((props.value / menuInfoStore.dishes * 100).toFixed(1));

        return isFinite(percent) ? percent : 0;
    },
});

</script>

<template>
    <div class="grid-item--percentage">
        <div class="grid-item--percentage__copy">
            <p class="grid-item__value" :style="{ color }">{{ value }}</p>
            <p>{{ text }}</p>
        </div>
        <ve-progress :progress="percentage" :thickness="20" :emptyThickness="20" :line="'butt'" :size="120"
            :color="color" :emptyColor="'var(--grey-light)'">
            <template v-slot:default="{ counterTick: { currentValue } }">
                <span>{{ currentValue }}%</span>
            </template>
        </ve-progress>
    </div>
</template>

